import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  margin: ${spacing.majorScale(2)}px 0;
`

export const TitleContainer = styled.div`
  margin-bottom: ${spacing.majorScale(2)}px;
`
